import { render, staticRenderFns } from "./PeriodFilter.vue?vue&type=template&id=20f1d65a"
import script from "./PeriodFilter.vue?vue&type=script&lang=js"
export * from "./PeriodFilter.vue?vue&type=script&lang=js"
import style0 from "./PeriodFilter.vue?vue&type=style&index=0&id=20f1d65a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports